__turbopack_context__.v({
  "revealed": "ingredient-list-stagger-module__5EPytG__revealed",
  "staggerHost": "ingredient-list-stagger-module__5EPytG__staggerHost",
});
